import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface Notification {
  id: number
  type: 'info' | 'success' | 'warning' | 'error'
  title: string
  message: string
  duration: number
}

/**
 * Monotonic id source. `Date.now() + Math.random()` produced a fractional id and
 * could collide, so `removeNotification` (which filters by id) could drop
 * several toasts at once.
 */
let nextNotificationId = 1

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: [] as Notification[],
  reducers: {
    addNotification(state, action: PayloadAction<Omit<Notification, 'id'>>) {
      const id = nextNotificationId++
      state.push({ ...action.payload, id })
    },
    removeNotification(state, action: PayloadAction<number>) {
      return state.filter((n) => n.id !== action.payload)
    },
    clearNotifications() {
      return []
    },
  },
})

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions
export default notificationsSlice.reducer
